import http from "@/utils/fetch";

export default {
    baseurl: '/api/swyl/v1/demo/bscReformToMaterial',

    selectPage(f) {   //改制目录
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: f
        });
    },

    selectById(id) {
        return http({
            url: this.baseurl+'/selectById?id=' + id,
            method: 'post',
        });
    },
    insert(query) {
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            data: query
        });
    },

    deleteById(query) {
        return http({
            url: this.baseurl+'/deleteById?id=' + query,
            method: 'post',
        });
    },
    updateById(query) {
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            data: query
        });
    },
    shenpi(query) {
        return http({
            url: this.baseurl+'/shenpi',
            method: 'post',
            data: query
        });
    },

    /**根据产品编码获取产品图片*/
    queryProductImageByBeCode(query) {
        return http({
            url: this.baseurl+'/queryProductImageByBeCode',
            method: 'get',
            params: query
        });
    },

    /**根据物料编码获取改制要求*/
    queryReformByMaterialCode(query) {
        return http({
            url: this.baseurl+'/queryReformByMaterialCode',
            method: 'get',
            params: query
        });
    },
}
